import {Component,OnInit,ViewChild,ElementRef} from '@angular/core';
import {EventService} from '../../core/services/event.service';
import {LAYOUT_WIDTH,SIDEBAR_TYPE,TOPBAR} from '../layouts.model';
//import { MenuItem } from '../../core/models/menu.model';
import {MenuItem} from '../horizontaltopbar/menu.model';
import {SharedService} from 'src/app/core/services/shared.service';
import {MenuEvent} from 'src/app/core/services/menuevent.service';
import {Subscription} from 'rxjs';
import { MenuService } from '../../core/services/menu.service';
import { URL_SERVICIOS } from '../../core/config/config'

@Component({
  selector: 'app-rightsidebar',
  templateUrl: './rightsidebar.component.html',
  styleUrls: ['./rightsidebar.component.scss']
})

/**
 * Rightsidebar component
 */
export class RightsidebarComponent implements OnInit {

  isVisible: string;
  attribute: string;

  width: string;
  sidebartype: string;
  topbar: string;
  strWsURLMENU: string = "api/mantenimientos/MenuPrincipal";
  //strWsModulo: string = "api/mantenimientos/MenuModulos";
  strWsModulo: string = "api/mantenimientos/MenuModulosNuevo";
  //MenuModulo: Array<any>;
  MenuModulo = [];
  menuItems = [];
  suscription: Subscription = null;
  mostrar: boolean = false;
  URL_ICONO = URL_SERVICIOS;
  @ViewChild('fileDescription') fileDescriptionInput: ElementRef;

  constructor(private eventService: EventService,
    private menuEvent: MenuEvent, private dataService: SharedService,
    public menuService: MenuService) { }

  ngOnInit() {
    this.width = LAYOUT_WIDTH;
    this.sidebartype = SIDEBAR_TYPE;
    this.topbar = TOPBAR;

    /**
     * horizontal-vertical layput set
     */
    this.attribute = document.body.getAttribute('data-layout');
    const vertical = document.getElementById('is-layout');
    /*if (vertical != null) {
      vertical.setAttribute('checked', 'true');
    }
    if (this.attribute == 'horizontal') {
      vertical.removeAttribute('checked');
    }
    */
    this.initialize();
    this.initialize2();
  }

  initialize(): void {
    this.dataService.Ejecutar(this.strWsModulo).subscribe(
      (datosResp2: any) => {
        this.MenuModulo = datosResp2.sort();
      });

  }
  initialize2() {
    let modulo = "";
    let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + "" + "\", \"S02COD\" : \"" + modulo + "\" }]}");
    this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
      (datosResp: any) => {
        this.menuItems = datosResp;
      });
  }
  hasItems(item: MenuItem) {
    return item.OPCIONES !== undefined ? item.OPCIONES.length > 0 : false;
  }

  AbrirMenu(intSYS02CON, descripcion,strSYS02TIP) {
    this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + intSYS02CON +  "\", \"SYS02TIP\" : \"" + strSYS02TIP + "\", \"titulo\": \"" + descripcion + "\"}"));
    document.body.classList.remove('right-bar-enabled');
    this.refresh();
    this.mostrar = false;
  }

  search(event) {
    var busqueda = event.target.value.toLowerCase();

    if (busqueda != "") {
      this.mostrar = true;
      let modulo = "";
      let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + busqueda + "\", \"S02COD\" : \"" + modulo + "\",\"MENU\": \"S\" }]}");
      this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
        (datosResp: any) => {
          this.menuItems = datosResp;
        });
    } else {
      this.mostrar = false;
      this.initialize();
    }
  }

  Modulo(intSYS02CON) {
//    if(intSYS02CON == "KIE" || intSYS02CON == "MAM"){
//      this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + "5" + "\", \"titulo\": \"" + "Servicio Estudiante" + "\", \"Tipo\": \"ESTUDIANTE_COMPONENT\",\"PAD18CON\": \"142385\"}"));
//    }else if(intSYS02CON == "SAP"){
//    if(intSYS02CON == "SAP") {
//      this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + "1" + "\", \"titulo\": \"" + "Servicio Docente" + "\", \"Tipo\": \"DOCENTE_COMPONENT\",\"PAD18CON\": \"142345\"}"));
//    }else{
      this.menuEvent.switchMessageForm(intSYS02CON);
//    }
    document.body.classList.remove('right-bar-enabled');
  }

  onMenuClick(event) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      nextEl.classList.toggle("show");
    }
    return false;
  }

  /**
   * Hide the sidebar
   */
  public hide() {
    document.body.classList.remove('right-bar-enabled');
    this.refresh();
  }
  
  refresh() {
    this.fileDescriptionInput.nativeElement.value = '';
  }

  /**
   * Change Topbar
   */
  changeTopbar(topbar: string) {
    this.topbar = topbar;
    this.eventService.broadcast('changeTopbar', topbar);
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout) {
    if (layout.target.checked == true)
      this.eventService.broadcast('changeLayout', 'vertical');
    else
      this.eventService.broadcast('changeLayout', 'horizontal');
  }

  changeWidth(width: string) {
    this.width = width;
    this.eventService.broadcast('changeWidth', width);
  }

  changeSidebartype(sidebar: string) {
    this.sidebartype = sidebar;
    this.eventService.broadcast('changeSidebartype', sidebar);
  }

}
